import { supabase } from '../lib/supabase';

export interface FiltrosAdminBase {
  provinciaEclesiasticaId?: string;
  diocesisId?: string;
  lumisialId?: string;
}

interface ProvinciaRef { readonly id: string; readonly nombre: string }
interface DiocesisRef { readonly id: string; readonly nombre: string; readonly tipo: 'diocesis' | 'prefectura' }

export interface LumisialConJerarquia {
  id: string;
  nombre: string;
  ciudad: string | null;
  provincia_eclesiastica_id: string | null;
  diocesis_id: string | null;
  provincia_eclesiastica: ProvinciaRef | ProvinciaRef[] | null;
  diocesis: DiocesisRef | DiocesisRef[] | null;
}

export async function getLumisialesFiltrados(filtros: FiltrosAdminBase): Promise<LumisialConJerarquia[]> {
  let query = supabase
    .from('lumisiales')
    .select(`
      id,
      nombre,
      ciudad,
      provincia_eclesiastica_id,
      diocesis_id,
      provincia_eclesiastica:provincia_eclesiastica_id(id, nombre),
      diocesis:diocesis_id(id, nombre, tipo)
    `)
    .eq('activo', true)
    .order('nombre');

  if (filtros.provinciaEclesiasticaId) {
    query = query.eq('provincia_eclesiastica_id', filtros.provinciaEclesiasticaId);
  }
  if (filtros.diocesisId) {
    query = query.eq('diocesis_id', filtros.diocesisId);
  }
  if (filtros.lumisialId) {
    query = query.eq('id', filtros.lumisialId);
  }

  const { data, error } = await query;
  if (error) throw error;
  return (data || []) as unknown as LumisialConJerarquia[];
}

function resolverProvinciaRef(val: ProvinciaRef | ProvinciaRef[] | null): ProvinciaRef | null {
  if (!val) return null;
  return Array.isArray(val) ? (val[0] ?? null) : val;
}

function resolverDiocesisRef(val: DiocesisRef | DiocesisRef[] | null): DiocesisRef | null {
  if (!val) return null;
  return Array.isArray(val) ? (val[0] ?? null) : val;
}

export function extraerDatosJerarquia(lumisial: LumisialConJerarquia) {
  const provincia = resolverProvinciaRef(lumisial.provincia_eclesiastica);
  const diocesis = resolverDiocesisRef(lumisial.diocesis);
  return {
    provinciaId: lumisial.provincia_eclesiastica_id || 'sin-provincia',
    provinciaNombre: provincia?.nombre || 'Sin Provincia',
    diocesisId: lumisial.diocesis_id?.toString() || 'sin-diocesis',
    diocesisNombre: diocesis?.nombre || 'Sin Diócesis',
    diocesisTipo: diocesis?.tipo || 'diocesis',
  };
}
